import type { BottomSheetModal } from '@gorhom/bottom-sheet';
import { IncentiveCategory } from '@varo/graphql-schema-types';
import { getIncentiveButtonAnalytics } from 'features/incentive/helpers/incentiveAnalytics';
import { IncentivePrerequisiteSheetCopy } from 'features/incentive/prerequisite/incentivePrerequisite';
import type { RefObject } from 'react';
import { StyleSheet, View } from 'react-native';
import { VaroPressableNames } from 'shared/analytics/types/pressableNames';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

interface IncentivePrerequisiteSheetProps {
  bottomSheetRef: RefObject<BottomSheetModal | null>;
  incentiveType: IncentiveCategory;
  copy: IncentivePrerequisiteSheetCopy;
  onStart: () => void;
  onSkip: () => void;
}

function IncentivePrerequisiteSheet({
  bottomSheetRef,
  incentiveType,
  copy,
  onStart,
  onSkip,
}: IncentivePrerequisiteSheetProps) {
  return (
    <BottomSheet ref={bottomSheetRef}>
      <View style={styles.contentContainer}>
        <TitleLgText numberOfLines={0} accessibilityRole="header">
          {copy.title}
        </TitleLgText>
        <BodyBaseText numberOfLines={0}>{copy.description}</BodyBaseText>
        <BodySmText numberOfLines={0} style={styles.disclaimer}>
          {copy.disclaimer}
        </BodySmText>
      </View>
      <View style={styles.buttonContainer}>
        <Button
          label={copy.startLabel}
          onPress={onStart}
          width="FULL"
          componentAnalytics={getIncentiveButtonAnalytics(
            incentiveType,
            VaroPressableNames.INCENTIVE.START_INCENTIVE_PREREQUISITE,
          )}
        />
        <Button
          label={copy.skipLabel}
          onPress={onSkip}
          type="SECONDARY"
          width="FULL"
          componentAnalytics={getIncentiveButtonAnalytics(
            incentiveType,
            VaroPressableNames.INCENTIVE.SKIP_INCENTIVE,
          )}
        />
      </View>
    </BottomSheet>
  );
}

const styles = StyleSheet.create({
  buttonContainer: {
    gap: theme.spacing.m,
    paddingBottom: theme.spacing.l,
    paddingHorizontal: theme.spacing.l,
    paddingTop: theme.spacing.xl,
  },
  contentContainer: {
    gap: theme.spacing.s,
    paddingHorizontal: theme.spacing.l,
    paddingTop: theme.spacing.m,
  },
  disclaimer: {
    color: theme.color.text.secondary,
    paddingTop: theme.spacing.m,
  },
});

export default IncentivePrerequisiteSheet;
